import { ReactNode } from 'react';
import { Flex, Typography, Col } from 'antd';
import styles from './Layout.module.css';
import {
  ButtonsSaveCancel,
  ButtonsSaveCancelProps,
} from '../ButtonsSaveCancel';

const { Title } = Typography;

interface ContentHeaderProps extends ButtonsSaveCancelProps {
  title: string;
  children?: ReactNode;
}

export const ContentHeader = ({
  title,
  children,
  ...rest
}: ContentHeaderProps) => {
  return (
    <Flex
      align="center"
      justify="space-between"
      className={styles.contentHeader}
    >
      <Col>
        <Title className={styles.contentHeaderTitle} level={3}>
          {title}
        </Title>
        {children}
      </Col>
      <ButtonsSaveCancel {...rest} />
    </Flex>
  );
};
